module.exports = __webpack_public_path__ + "media/images/creators_circle/2023/footer_illustration-c2c266355936e4b583059663cf059640.png";